// test2986
(2986 && 0);
